import React from 'react';
import { Box, Breadcrumbs, Typography } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Link } from 'react-router-dom';

function Breadcrumb({ items }) {
    if (!items || items.length === 0) return null;

    const hasPath = (item) => item.path && item.path !== '';

    return (
        <Box sx={{ mb: 3 }}>
            <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                {/* Home icon that links to home page */}
                <Link
                    to="/"
                    style={{ 
                        textDecoration: 'none', 
                        color: 'inherit',
                        display: 'flex',
                        alignItems: 'center'
                    }}
                >
                    <HomeIcon fontSize="small" />
                </Link>
                
                {items.map((item, index) => {
                    const isLast = index === items.length - 1;
                    
                    if (isLast) {
                        return (
                            <Typography key={index} color="text.primary" fontWeight={500}>
                                {item.label}
                            </Typography>
                        );
                    }
                    
                    // Only make it clickable if it has a path
                    if (hasPath(item)) {
                        return (
                            <Link
                                key={index}
                                to={item.path}
                                style={{ textDecoration: 'none', color: 'inherit' }}
                            >
                                {item.label}
                            </Link>
                        );
                    }
                    
                    return (
                        <Typography key={index} color="text.secondary">
                            {item.label}
                        </Typography>
                    );
                })}
            </Breadcrumbs>
        </Box>
    );
}

export default Breadcrumb;

